
class CapViewVendor {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_vendor'
}

function create(config) {
  return new CapViewVendor(config)
}

export default {
  key,
  create,
}
